import { LucideRows2 } from "lucide-react";
import { LuSearch, LuChevronDown } from "@/Components/Icons/Icons.jsx";

export default {
    row1 : [
    {
        column: "column1",
        columnWidth: "35%",
        rows: {
            row1: [
                {
                    name: "Preferred Delivery Handler",
                    component: "header",
                },
            ],
            row2: [
                {
                    name: "consigneePreferredDeliveryAir",
                    label: "Air",
                    component: "text-field",
                    icon: LuSearch,
                    iconColor: "gray-400",
                    type: "autocomplete",
                    endpoint:"getCustomer"
                }

            ],
            row3: [
                {
                    name: "consigneePreferredDeliveryLCL",
                    label: "LCL",
                    component: "text-field",
                    icon: LuSearch,
                    iconColor: "gray-400",
                    type: "autocomplete",
                    endpoint:"getCustomer"
                }

            ],
            row4: [
                {
                    name: "consigneePreferredDeliveryFCL",
                    label: "FCL",
                    component: "text-field",
                    icon: LuSearch,
                    iconColor: "gray-400",
                    type: "autocomplete",
                    endpoint:"getCustomer"
                }

            ],
            row5: [
                {
                    name: "Delivery Coordinator",
                    component: "header",
                },

            ],
            row6: [
                {
                    name: "consigneeCoordinatorSea",
                    label: "For Sea",
                    component: "text-field",
                    icon: LuSearch,
                    iconColor: "gray-400",
                    endpoint: "getShipperQuery",
                    type: "autocomplete",

                }

            ],
            row7: [
                {
                    name: "consigneeCoordinatorAir",
                    label: "For Air",
                    component: "text-field",
                    icon: LuSearch,
                    iconColor: "gray-400",
                    endpoint: "getShipperQuery",
                    type: "autocomplete",

                }

            ],
            row8: [
                {
                    name: "Customer Services",
                    component: "header",
                },

            ],
            row9: [
                {
                    name: "consigneeServicesSea",
                    label: "For Sea",
                    component: "text-field",
                    icon: LuSearch,
                    iconColor: "gray-400",
                    endpoint: "getShipperQuery",
                    type: "autocomplete",
                }

            ],
            row10: [
                {
                    name: "consigneeServicesAir",
                    label: "For Air",
                    component: "text-field",
                    icon: LuSearch,
                    iconColor: "gray-400",
                    endpoint: "getShipperQuery",
                    type: "autocomplete",

                }

            ]
        }
    },
    {
        column: "column1",
        columnWidth: "35%",
        rows: {
            row1: [
                {
                    name: "Account Manager",
                    component: "header",
                },
            ],
            row2: [
                {
                    name: "accountManagerSea",
                    label: "For Sea",
                    component: "dropdown",
                    endIconName: "LuChevronDown",
                    iconColor: "gray-400",
                    options: [
                        { label: "Administrator", value: "Administrator" },
                        { label: "Ajitesh Barick", value: "Ajitesh Barick" },
                        { label: "Anjan Reddy", value: "Anjan Reddy" },
                        { label: "Boopathy", value: "Boopathy" },
                        { label: "Chandra", value: "Chandra" },
                        { label: "Dinesh Singh Rajput", value: "Dinesh Singh Rajput" },
                        { label: "Export Del", value: "Export Del" },
                        { label: "Karthik", value: "Karthik" },
                        { label: "Kiran Kumar V", value: "Kiran Kumar V" },
                        { label: "Mohan Reddy", value: "Mohan Reddy" },
                        { label: "Mythri", value: "Mythri" },
                        { label: "Shiva", value: "Shiva" },
                        { label: "SUREKSHA", value: "SUREKSHA" },
                        { label: "TAPAN", value: "TAPAN" },
                        { label: "Tripath Mumbai", value: "Tripath Mumbai" },
                        { label: "TRIPATH MUMBAI 1", value: "TRIPATH MUMBAI 1" },
                        { label: "TRIPATHMAA", value: "TRIPATHMAA" },
                        { label: "TRIPATH MUMBAI", value: "TRIPATH MUMBAI" },
                      ],

                }

            ],
            row3: [
                {
                    name: "accountManagerAir",
                    label: "For Air",
                    component: "dropdown",
                    endIconName: "LuChevronDown",
                    iconColor: "gray-400",
                    options: [
                        { label: "Administrator", value: "Administrator" },
                        { label: "Ajitesh Barick", value: "Ajitesh Barick" },
                        { label: "Anjan Reddy", value: "Anjan Reddy" },
                        { label: "Boopathy", value: "Boopathy" },
                        { label: "Chandra", value: "Chandra" },
                        { label: "Dinesh Singh Rajput", value: "Dinesh Singh Rajput" },
                        { label: "Export Del", value: "Export Del" },
                        { label: "Karthik", value: "Karthik" },
                        { label: "Kiran Kumar V", value: "Kiran Kumar V" },
                        { label: "Mohan Reddy", value: "Mohan Reddy" },
                        { label: "Mythri", value: "Mythri" },
                        { label: "Shiva", value: "Shiva" },
                        { label: "SUREKSHA", value: "SUREKSHA" },
                        { label: "TAPAN", value: "TAPAN" },
                        { label: "Tripath Mumbai", value: "Tripath Mumbai" },
                        { label: "TRIPATH MUMBAI 1", value: "TRIPATH MUMBAI 1" },
                        { label: "TRIPATHMAA", value: "TRIPATHMAA" },
                        { label: "TRIPATH MUMBAI", value: "TRIPATH MUMBAI" },
                      ],

                }

            ],
            row4: [
                {
                    name: "accountManagerLand",
                    label: "For Land",
                    component: "dropdown",
                    endIconName: "LuChevronDown",
                    iconColor: "gray-400",
                    options: [
                        { label: "Administrator", value: "Administrator" },
                        { label: "Ajitesh Barick", value: "Ajitesh Barick" },
                        { label: "Anjan Reddy", value: "Anjan Reddy" },
                        { label: "Boopathy", value: "Boopathy" },
                        { label: "Chandra", value: "Chandra" },
                        { label: "Dinesh Singh Rajput", value: "Dinesh Singh Rajput" },
                        { label: "Export Del", value: "Export Del" },
                        { label: "Karthik", value: "Karthik" },
                        { label: "Kiran Kumar V", value: "Kiran Kumar V" },
                        { label: "Mohan Reddy", value: "Mohan Reddy" },
                        { label: "Mythri", value: "Mythri" },
                        { label: "Shiva", value: "Shiva" },
                        { label: "SUREKSHA", value: "SUREKSHA" },
                        { label: "TAPAN", value: "TAPAN" },
                        { label: "Tripath Mumbai", value: "Tripath Mumbai" },
                        { label: "TRIPATH MUMBAI 1", value: "TRIPATH MUMBAI 1" },
                        { label: "TRIPATHMAA", value: "TRIPATHMAA" },
                        { label: "TRIPATH MUMBAI", value: "TRIPATH MUMBAI" },
                      ],

                }

            ],
            row5: [
                {
                    name: "Currency Uplift(CFX)",
                    component: "header",
                },
            ],
            row6: [
                {
                    name: "currencyUpliftAir",
                    label: "Air",
                    component: "dropdown",
                    endIconName: "LuChevronDown",
                    iconColor: "gray-400",
                    width: "30%"

                },
                {
                    name: "currencyUpliftAirValue",
                    component: "text-field",
                    width: "70%"


                }

            ],
            row7: [
                {
                    name: "currencyUpliftSea",
                    label: "Sea",
                    component: "dropdown",
                    endIconName: "LuChevronDown",
                    iconColor: "gray-400",
                    width: "30%"

                },
                {
                    name: "currencyUpliftSeaValue",
                    component: "text-field",
                    width: "70%"


                }

            ]
        }
    }
]
}